export default "__VITE_ASSET__HWth8B_o__"